<aside class="col-md-12 third__party__consignment mb-4 position-relative px-5">
    <i *ngIf="dataDialog.thirdParty" matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions t-0"
        (click)="dialogRef.close()"></i>
    <div class="title-component">
        <div class="col-md-12 mt-4 px-0">
            <i class="fas fa-building"></i>
            Detalle del tercero
        </div>
    </div>
    <h4>{{thirdParty?.name}}</h4>
    <div class="d-flex flex-wrap text-bold">
        <p class="mr-2">{{getDocumentType()}}:</p>
        <p>{{thirdParty?.document}}</p>
    </div>
    <div class="d-flex flex-wrap-reverse">
        <mat-form-field appearance="outline" class="col-md-6 px-0">
            <mat-label>Nombre de sede</mat-label>
            <input type="text" matInput [(ngModel)]="thirdPartyAddressFilter">
        </mat-form-field>
        <div class="d-flex justify-content-end col-md-6 m-0 p-0 pb-3" permission-display
            [module]="permission.administration.module"
            [functionality]="permission.administration.createThirdPartyAddress">
            <button matTooltip="Crear sede" mat-raised-button color="primary"
                class="bg-color-primary button-width-auto text-bold" (click)="createThirdPartyAddress()">
                <i class="fas fa-plus-circle mr-2 d-none d-sm-inline"></i>
                <span>Crear sede</span>
            </button>
        </div>
    </div>

    <div class="container-list-body">
        <div class="col-md-12 px-0 mb-md-0 mb-12"
            *ngFor="let thirdPartyAddress of filteredThirdPartyAddresses | filterThirdPartyAddresses:thirdPartyAddressFilter">
            <app-third-party-address-item [thirdPartyAddress]="thirdPartyAddress" [thirdParty]="thirdParty"
                [addressId]="addressId" [city]="municipalityCodes[thirdPartyAddress.municipalityCode]"
                (refreshList)="getThirdPartyAddresses()"></app-third-party-address-item>
        </div>
    </div>
</aside>